.appLogoContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.7rem;

  >img:first-child {
    height: 50px;
  }

  >div:nth-child(2) {
    margin-top: 0.8rem;
    height: fit-content;
    width: fit-content;
    text-align: left;

    >span {
      font-size: 0.77rem;
    }
  }

}